import classNames from 'classnames';
import styles from './FJGuideModal.module.less';
import PropTypes from 'prop-types';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import { useEffect, useCallback, useState, useRef } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';

const FJGuideModal = ({ data }) => {
    const {
        setpNumTitle,
        setpTitle,
        setpContent,
        skipBtnText,
        nextBtnText,
        relativeDomPosition,
        arrowDirection = 'left',
        skipBtnCallback,
        nextBtnCallback,

        domId,
        isShowDom = false,
    } = data;

    const [position, setPosition] = useState(null);
    const [offset, setOffset] = useState({
        x: 0,
        y: 0,
    });
    const containerRef = useRef(null);

    const updateView = useCallback(() => {
        const showDomContainer = document.getElementById('showDomContainer');
        if (showDomContainer) {
            showDomContainer.remove();
        }

        if (domId) {
            const dom = document.getElementById(domId);

            if (!dom) return;
            const rect = dom.getBoundingClientRect();

            const offsetX = relativeDomPosition.x.includes('%')
                ? rect.width * (parseFloat(relativeDomPosition.x) / 100)
                : relativeDomPosition.x;
            const offsetY = relativeDomPosition.y.includes('%')
                ? rect.height * (parseFloat(relativeDomPosition.y) / 100)
                : relativeDomPosition.y;

            let position = {
                left: rect.left + offsetX,
                top: rect.top + offsetY,
            };

            if (containerRef.current) {
                let offsetX = 0;
                let offsetY = 0;
                const viewSize = {
                    width: window.innerWidth,
                    height: window.innerHeight,
                };
                const containerRect = containerRef.current.getBoundingClientRect();
                if (position.left + containerRect.width / 2 > viewSize.width) {
                    offsetX = position.left - (viewSize.width - containerRect.width / 2 - 10);
                    position.left = viewSize.width - containerRect.width / 2 - 10;
                }
                if (position.top + containerRect.height / 2 > viewSize.height) {
                    offsetY = position.top - (viewSize.height - containerRect.height / 2 - 10);
                    position.top = viewSize.height - containerRect.height / 2 - 10;
                }

                setOffset({
                    x: offsetX,
                    y: offsetY,
                });
            }

            setPosition(position);

            const __showDom = () => {
                // 复制dom 到顶层显示
                const cloneDom = dom.cloneNode(true);
                const showDomContainer = document.createElement('div');
                showDomContainer.id = 'showDomContainer';
                document.body.appendChild(showDomContainer);
                showDomContainer.appendChild(cloneDom);

                cloneDom.style.position = 'fixed';
                cloneDom.style.left = rect.left + 'px';
                cloneDom.style.top = rect.top + 'px';
                cloneDom.style.width = rect.width + 'px';
                cloneDom.style.height = rect.height + 'px';
                cloneDom.style.zIndex = 999999;
                cloneDom.style.pointerEvents = 'none';
                cloneDom.style.margin = '0';

                // 特别处理 canvas 元素
                const canvasElements = cloneDom.getElementsByTagName('canvas');
                Array.from(canvasElements).forEach(canvas => {
                    // 获取原始 canvas 的内容
                    const originalCanvas = dom.querySelector('canvas');
                    if (originalCanvas) {
                        const context = canvas.getContext('2d');
                        canvas.width = originalCanvas.width;
                        canvas.height = originalCanvas.height;
                        // 复制 canvas 内容
                        context.drawImage(originalCanvas, 0, 0);
                    }
                });
            };

            if (isShowDom) {
                __showDom();
            }
        }
    }, [domId, isShowDom, relativeDomPosition]);

    useEffect(() => {
        updateView();

        window.addEventListener('resize', updateView);

        return () => {
            window.removeEventListener('resize', updateView);
        };
    }, [updateView]);

    return (
        <div
            className={classNames(styles.container, {
                [styles.bottom]: arrowDirection === 'bottom',
                [styles.top]: arrowDirection === 'top',
                [styles.left]: arrowDirection === 'left',
                [styles.right]: arrowDirection === 'right',
            })}
            ref={containerRef}
            style={{
                left: position?.left,
                top: position?.top,
                '--offset-x': `${offset.x}px`,
                '--offset-y': `${offset.y}px`,
            }}
        >
            <div
                className={classNames(styles.gradient_bg, {
                    [styles.bottom]: arrowDirection === 'bottom',
                    [styles.top]: arrowDirection === 'top',
                    [styles.left]: arrowDirection === 'left',
                    [styles.right]: arrowDirection === 'right',
                })}
            ></div>

            <div className={styles.container_content}>
                <div className={styles.setp_num_title}>{FJLocalStore._(setpNumTitle)}</div>
                <div className={styles.setp_title}>{FJLocalStore._(setpTitle)}</div>
                <div className={styles.setp_content}>{FJLocalStore._(setpContent)}</div>
                <div className={styles.btn_container}>
                    <div className={styles.skip_btn} onClick={skipBtnCallback}>
                        {skipBtnText && skipBtnText !== '' && FJLocalStore._(skipBtnText)}
                    </div>

                    <FJButton
                        className={styles.next_btn}
                        textClassName={styles.next_btn_text}
                        type={FJButtonType.GRADIENT}
                        text={FJLocalStore._(nextBtnText)}
                        onClick={nextBtnCallback}
                    ></FJButton>
                </div>
            </div>
        </div>
    );
};

FJGuideModal.propTypes = {
    data: PropTypes.object.isRequired,
};

export default FJGuideModal;
